import React from 'react';

export default class FacultyStaffAdminRegistration extends React.Component {
  render() {
    return null;
  }
}
